import * as consts from './AppConsts';

const initialState = {
    tourId: 0,
    tourType: '',
    getTourFulfilled: false,
    getTourError: '',
    contentBlur: 0,
    isDrafted: false,
    isLogined: false,
    isActive: false,
    backgroundPhoto: null,
    theme: 'traditional',
    elementToScroll: null,
    buttonsVisibility: {
        threeDModelBtnVisible: false,
        floorplanBtnVisible: false,
        matterportBtnVisible: false,
        videoBtnVisible: false,
        mapBtnVisible: false,
        infoBtnVisible: false,
        shareBtnVisible: false,
        walkthruBtnVisibility: false,
        descriptionBtnVisible: false,
        propertyDetailsBtnVisibility: true,
        documentsBtnVisibility: false,
        presentedByBtnVisibility: false,
        otherListingsVisibility: false,
        locationVisibility: false,
        claimHomeBtnVisibility: false
    },
    orderBottomLogo: {
        logo: '',
        url: ''
    },
    story_components_order: [],
    poweredByLogo: '',
    isFullscreen: false
};

const app = (state = initialState, action) => {
    switch (action.type) {
        case consts.SET_URL_PARAMS:
            return {
                ...state,
                tourId: action.payload.tourId,
                tourType: action.payload.tourType
            }
        case consts.GET_TOUR_PENDING:
            return {
                ...state,
                getTourFulfilled: false
            }
        case consts.GET_TOUR_REJECTED:
            return {
                ...state,
                getTourFulfilled: true
            }
        // check rootReducer.js for GET_TOUR_FULFILLED
        case consts.GET_BACKGROUND_PHOTO_FULFILLED:
            return {
                ...state,
                backgroundPhoto: action.payload
            }
        case consts.SET_CONTENT_BLUR:
            return {
                ...state,
                contentBlur: action.payload
            }
        case consts.SAVE_POSITION:
            return {
                ...state,
                elementToScroll: action.payload
            }
        case consts.CLEAR_POSITION:
            return {
                ...state,
                elementToScroll: null,
                isFullscreen: false
            }
        case consts.TOGGLE_FULLSCREEN:
            return {
                ...state,
                isFullscreen: action.payload
            }
        default:
            return state
    }
}

export default app;
